/* Sends a waitlist signup to Klaviyo without leaving the product page.
 *
 * The form underneath is a genuine Shopify customer form. If anything here
 * fails, or JavaScript never runs, the browser submits it normally and the
 * address is still captured as a tagged customer. So every path keeps the
 * lead; this one just puts it somewhere Hugo can mail from.
 */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/';

  function post(path, company, payload) {
    return fetch(ENDPOINT + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    });
  }

  function subscribe(box, email) {
    var company = box.dataset.company;
    var listId = box.dataset.list;
    var product = box.dataset.product;

    var subscription = post('subscriptions', company, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Waitlist, ' + product,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { 'Waitlist Product': product }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });

    /* A separate event, because the profile property above is overwritten if
       somebody waits on a second product. The event keeps every one of them. */
    var event = post('events', company, {
      data: {
        type: 'event',
        attributes: {
          properties: {
            'Product Title': product,
            'Product Handle': box.dataset.handle,
            'Product URL': box.dataset.url
          },
          metric: { data: { type: 'metric', attributes: { name: 'Joined Waitlist' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });

    return Promise.all([subscription, event]).then(function (responses) {
      if (!responses[0].ok) throw new Error('subscription rejected');
      return true;
    });
  }

  function succeed(box, email) {
    var product = box.dataset.product || 'it';
    var note = document.createElement('p');
    note.className = 'ma-waitlist__ok';
    note.setAttribute('role', 'status');
    /* The titles already begin with "The", so no article is added here and
       the name is not lowercased: "the moment the the heritage snapback"
       is what the obvious version produces. */
    note.textContent =
      'You are on the list. We will write to ' + email +
      ' the moment ' + product + ' arrives.';
    var form = box.querySelector('form');
    form.replaceWith(note);
  }

  document.querySelectorAll('[data-ma-waitlist]').forEach(function (box) {
    var form = box.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var field = form.querySelector('input[type="email"]');
      if (!field || !field.value || !field.checkValidity()) return;

      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding you';
      }

      subscribe(box, field.value)
        .then(function () {
          succeed(box, field.value);
        })
        .catch(function () {
          /* Hand it back to Shopify rather than losing the address. */
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
          form.submit();
        });
    });
  });
})();
